export default __webpack_public_path__ + "static/media/01_photo.a58041c4.jpg";